module.exports = __webpack_public_path__ + "img/m-3.942e37c3.png";